import {
  makeObservable,
  observable,
  action,
  computed,
  runInAction,
} from "mobx";
import { IObservableInitialState } from "../../models/ICommon";
import * as baseService from "../service/base-service";
import URLConstants from "../../constants/url.constants";
import toast from "react-hot-toast";
import { formatMessage } from "../../translations/format-message";
import IApiResponse, {
  IApiSuccessResponse,
} from "../../models/response/IApiResponse";
import { getLanguageFromLocalStorage } from "../../helpers/local-stotrage-helper";
import moment from "moment";
import FotaStatusEnum from "../../constants/fota-status-enum";
import { IFotaDeviceStatusFilter } from "../../models/response/IFotaNewResponse";
import { IFotaDevicesStatusList, IFotaDevicesStatusListVm } from "../../models/response/IFotaSchedulerDevicesResponse";
import { getInitialFotaSchedulerDeviceStatusState } from "../initial-state/get-fota-schedule-devices-status-state";
import TerminationTypeEnum from "../../constants/termination-type-enum";
import { DATE_TIME_FORMAT, DATE_TIME_FORMAT_WITHOUT_SECONDS, emptyValue, emptyValueHyphen } from "../../constants/common-constants";
import fotaViewTypeEnum from "../../constants/fota-view-type-enum";

export class SchedulerHistoryStore {
  initialStateValue = {
    success: false,
    error: '',
    inProgress: false
  }
  error: string | null = null;
  inProgress: boolean = false;

  schedulerDeviceStatusList: IFotaDevicesStatusListVm = getInitialFotaSchedulerDeviceStatusState;
  schedulerDeviceStatusListState: IObservableInitialState = { ...this.initialStateValue }

  initialFilter: IFotaDeviceStatusFilter = {
    SearchBy: -1,
    ICCID: "",
    Status: 0,
    // StartDate:moment(new Date()).subtract(7, 'days').format(DATE_TIME_FORMAT_WITHOUT_SECONDS),
    // EndDate:moment(new Date()).format(DATE_TIME_FORMAT_WITHOUT_SECONDS),
    LastSegmentRequestTimestampStartDate: "",
    LastSegmentRequestTimestampEndDate: "",
    DeviceRebootedMessage: "",
    isFilterActive: false
  }

  filterDetails: IFotaDeviceStatusFilter = {
    ...this.initialFilter
  }

  abortDeviceScheduleState: IObservableInitialState = { ...this.initialStateValue }
  abortSelectedDeviceScheduleState: IObservableInitialState = { ...this.initialStateValue }
  deleteFotaDeviceScheduleState: IObservableInitialState = { ...this.initialStateValue }

  constructor() {
    makeObservable(this, {
      inProgress: observable,
      error: observable,
      abortDeviceScheduleState: observable,
      abortSelectedDeviceScheduleState: observable,
      deleteFotaDeviceScheduleState: observable,

      schedulerDeviceStatusList: observable,
      schedulerDeviceStatusListState: observable,
      filterDetails: observable,

      GetFotaSchedulerDeviceStatusListService: action,
      AbortFotaDeviceHostScheduleByScheduleIdService: action,
      AbortFotaDeviceJetScheduleByScheduleIdService: action,
      AbortFotaDeviceModemScheduleByScheduleIdService: action,
      AbortFotaDeviceScheduleByDeviceListService: action,
      DeleteFotaDeviceScheduleService: action,

      reset: action,
      resetStore: action,
      resetSchedulerDeviceStatusListState: action,
      resetAbortDeviceScheduleState: action,
      resetAbortSelectedDeviceScheduleState: action,
      resetDeleteFotaDeviceScheduleState: action,
      setFilterDetail: action,

      getFotaSchedulerDeviceStatusList: computed,

    });
  }

  /**
   * Fetches a list of FotaSchedulerDeviceStatus items.
   * @param currentPage - Current page number.
   * @param pageSize - Number of items per page.
   */
  GetFotaSchedulerDeviceStatusListService = (currentPage: number, pageSize: number, selectedView: fotaViewTypeEnum, schedulerId: number, filter: any) => {
    runInAction(() => (this.schedulerDeviceStatusListState.inProgress = true));
    var url = "";
    if (selectedView == fotaViewTypeEnum.Host) url = URLConstants.GetFotaHostSchedulerDevicesList;
    else if (selectedView == fotaViewTypeEnum.Modem) url = URLConstants.GetFotaModemSchedulerDevicesList;
    else if (selectedView == fotaViewTypeEnum.Jet) url = URLConstants.GetFotaJetSchedulerDevicesList;

    let tempSearchBy: number = parseInt(filter.SearchBy)
    let requestBody = {
      Id: schedulerId,
      SearchBy: tempSearchBy > 0 ? tempSearchBy : 0,
      ICCID: tempSearchBy === 1 ? filter.ICCID : "",
      LastSegmentRequestTimestampStartDate: tempSearchBy === 2 ? filter.LastSegmentRequestTimestampStartDate : null,
      LastSegmentRequestTimestampEndDate: tempSearchBy === 2 ? filter.LastSegmentRequestTimestampEndDate : null,
      DeviceRebootedMessage: tempSearchBy === 4 ? filter.DeviceRebootedMessage : "",
      Status: tempSearchBy === 3 ? filter.Status : 0,
      PagingDetails: {
        PageNo: currentPage,
        PageSize: pageSize,
        TotalPages: 0,
        TotalRecords: 0
      },
    }
    return baseService
      .postRequest(url, requestBody)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaDevicesStatusListVm>>) => {
        if (response.data.Error) {
          toast.error(formatMessage(response.data.Message));
        } else {
          runInAction(() => {
            this.schedulerDeviceStatusList = response.data.Data;
          });
        }
      })
      .catch((err) => {
        toast.error(formatMessage(err))
      })
      .finally(() => {
        runInAction(() => (this.schedulerDeviceStatusListState.inProgress = false));
      });
  };

  /**
    * This function is used to map releaseSchedulerHistoryList to ReleaseSchedulerHistory List suitable for Grid Component.
    * @returns Initial ReleaseSchedulerHistory Details
    */
  get getFotaSchedulerDeviceStatusList(): IFotaDevicesStatusList[] {
    if (
      this.schedulerDeviceStatusList &&
      this.schedulerDeviceStatusList.DevicesFotaStatusHistory.length > 0
    ) {
      return this.schedulerDeviceStatusList.DevicesFotaStatusHistory.map((deviceStatus, index) => {
        const language = getLanguageFromLocalStorage();
        const status = deviceStatus.Status;

        const isAbort =
          status === FotaStatusEnum.Initiated ||
          status === FotaStatusEnum.InProgress;

        const isDelete =
          status === FotaStatusEnum.Pending ||
          status === FotaStatusEnum.Success ||
          status === FotaStatusEnum.Aborted ||
          status === FotaStatusEnum.Failed;

        return {
          Id: deviceStatus.Id,
          ICCID: deviceStatus.ICCID ?? "",
          Status: status,
          StatusValue: FotaStatusEnum[status],
          TotalSegment: deviceStatus.TotalSegment,
          LastSegmentNoRequestedByDevice: deviceStatus.LastSegmentNoRequestedByDevice,
          LastSegmentRequestTimestamp: deviceStatus.LastSegmentRequestTimestamp
            ? moment(deviceStatus.LastSegmentRequestTimestamp).format(DATE_TIME_FORMAT)
            : emptyValueHyphen,
          TerminationType: deviceStatus.TerminationType,
          TerminationTypeValue:
            deviceStatus.TerminationType === TerminationTypeEnum.None
              ? emptyValueHyphen
              : TerminationTypeEnum[deviceStatus.TerminationType],
          TerminationDateTimestamp: deviceStatus.TerminationDateTimestamp
            ? moment(deviceStatus.TerminationDateTimestamp).format(DATE_TIME_FORMAT)
            : emptyValueHyphen,
          TerminationReasonRemark: deviceStatus.TerminationReasonRemark || emptyValueHyphen,
          DeviceRebootedMessage: deviceStatus.DeviceRebootedMessage || emptyValueHyphen,
          Language: language,

          isAbort,
          isDelete,
        };
      });
    }
    return [];
  }


  resetSchedulerDeviceStatusListState = () => {
    this.schedulerDeviceStatusList = getInitialFotaSchedulerDeviceStatusState;
    this.schedulerDeviceStatusListState = { ...this.initialStateValue };
  }

  AbortFotaDeviceHostScheduleByScheduleIdService = (id: number) => {
    this.abortDeviceScheduleState.inProgress = true;
    const url = URLConstants.FotaHostScheduler + "/" + id + "/Abort";
    return baseService.putRequest(url, {})
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            toast.error(formatMessage(response.data.Message));
          } else {
            this.abortDeviceScheduleState.success = true;
          }
        }
      )
      .catch((err: any) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        this.abortDeviceScheduleState.inProgress = false;
      });
  };

  resetAbortDeviceScheduleState = () => {
    this.abortDeviceScheduleState = { ...this.initialStateValue };
  }
  AbortFotaDeviceJetScheduleByScheduleIdService = (id: number) => {
    this.abortDeviceScheduleState.inProgress = true;
    const url = URLConstants.FotaJetScheduler + "/" + id + "/Abort";
    return baseService.putRequest(url, {})
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            toast.error(formatMessage(response.data.Message));
          } else {
            this.abortDeviceScheduleState.success = true;
          }
        }
      )
      .catch((err: any) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        this.abortDeviceScheduleState.inProgress = false;
      });
  };

  AbortFotaDeviceModemScheduleByScheduleIdService = (id: number) => {
    this.abortDeviceScheduleState.inProgress = true;
    const url = URLConstants.FotaModemScheduler + "/" + id + "/Abort";
    return baseService.putRequest(url, {})
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            toast.error(formatMessage(response.data.Message));
          } else {
            this.abortDeviceScheduleState.success = true;
          }
        }
      )
      .catch((err: any) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        this.abortDeviceScheduleState.inProgress = false;
      });
  };


  AbortFotaDeviceScheduleByDeviceListService = (schedulerId: number, iccids: string[], selectedView: fotaViewTypeEnum) => {
    this.abortSelectedDeviceScheduleState.inProgress = true;
    let url = "";
    if (selectedView == fotaViewTypeEnum.Host) url = URLConstants.FotaHostScheduler + "/" + schedulerId + "/Devices/Abort";
    else if (selectedView == fotaViewTypeEnum.Modem) url = URLConstants.FotaModemScheduler + "/" + schedulerId + "/Devices/Abort";
    else if (selectedView == fotaViewTypeEnum.Jet) url = URLConstants.FotaJetScheduler + "/" + schedulerId + "/Devices/Abort";
    return baseService.putRequest(url, iccids)
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            toast.error(formatMessage(response.data.Message));
          } else {
            this.abortSelectedDeviceScheduleState.success = true;
          }
        }
      )
      .catch((err: any) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        this.abortSelectedDeviceScheduleState.inProgress = false;
      });
  };

  resetAbortSelectedDeviceScheduleState = () => {
    this.abortSelectedDeviceScheduleState = { ...this.initialStateValue };
  }

  /**
    * This function is used to Delete User by calling an API.
    * @param id : The User Identifier
    * @returns 
    */
  DeleteFotaDeviceScheduleService = (scheudulerId: number, iccids: string[], selectedView: fotaViewTypeEnum) => {
    this.deleteFotaDeviceScheduleState.inProgress = true;
    let url = "";
    if (selectedView == fotaViewTypeEnum.Host) url = `${URLConstants.FotaHostScheduler}/${scheudulerId}/Devices`;
    else if (selectedView == fotaViewTypeEnum.Modem) url = `${URLConstants.FotaModemScheduler}/${scheudulerId}/Devices`;
    else if (selectedView == fotaViewTypeEnum.Jet) url = `${URLConstants.FotaJetScheduler}/${scheudulerId}/Devices`;
    return baseService.deleteRequestWithData(url, iccids)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteFotaDeviceScheduleState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        }
        else this.deleteFotaDeviceScheduleState.success = true;
      })
      .catch((err: string) => {
        this.deleteFotaDeviceScheduleState.error = err;
      }).finally(action(() => { this.deleteFotaDeviceScheduleState.inProgress = false; }));
  }

  resetDeleteFotaDeviceScheduleState = () => {
    this.deleteFotaDeviceScheduleState = { ...this.initialStateValue };
  };

  /**
   * Resets all observables to their initial values.
   */
  reset = () => {
    this.error = "";
    this.inProgress = false;
  };

  resetStore = () => {
    this.error = null;
    this.inProgress = false;
    this.schedulerDeviceStatusList = getInitialFotaSchedulerDeviceStatusState;
    this.schedulerDeviceStatusListState = { ...this.initialStateValue };
    this.filterDetails = { ...this.initialFilter }
  };

  setFilterDetail = (filter: any) => {
    this.filterDetails = { ...filter };
  }

}
const schedulerHistoryStore = new SchedulerHistoryStore();
export default schedulerHistoryStore;
